import React from "react";
import { baseRadius, nodeGapFor } from "src/config";
const nodeGap = nodeGapFor(baseRadius);
export default function EphemeralNode(props) {
    const { version, node, x, y, radius } = props;
    if (!node) {
        return null;
    }
    else {
        return (React.createElement(React.Fragment, null,
            node.left ? (React.createElement(React.Fragment, null,
                React.createElement("line", { strokeWidth: "1.5px", stroke: "blue", x1: x - nodeGap, y1: y + nodeGap, x2: x, y2: y }),
                React.createElement(EphemeralNode, { version: version, node: node.left, x: x - nodeGap, y: y + nodeGap, radius: radius }))) : null,
            node.right ? (React.createElement(React.Fragment, null,
                React.createElement("line", { strokeWidth: "1.5px", stroke: "green", x1: x + nodeGap, y1: y + nodeGap, x2: x, y2: y }),
                React.createElement(EphemeralNode, { version: version, node: node.right, x: x + nodeGap, y: y + nodeGap, radius: radius }))) : null,
            React.createElement("circle", { cx: x, cy: y, r: radius, fill: "white", strokeWidth: 1, stroke: "black" }),
            React.createElement("text", { textAnchor: "middle", alignmentBaseline: "central", x: x, y: y }, node.value)));
    }
}
